(() => {
  if (window.__baQuickAddLoaded) return;
  window.__baQuickAddLoaded = true;

  const placeQuickAdds = (root = document) => {
    root.querySelectorAll('[data-ba-quick-add]').forEach((quickAdd) => {
      if (quickAdd.dataset.baOverlayPlaced === 'true') return;
      const card = quickAdd.closest('.ba-mould__item, .ba-product-row__item, product-card');
      if (!card) return;
      const media = card.querySelector('.ba-mould__media, .ba-product-row__media, .product-card__figure');
      if (!media) return;
      media.appendChild(quickAdd);
      quickAdd.dataset.baOverlayPlaced = 'true';
    });
  };

  const initQuickAdds = () => placeQuickAdds(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuickAdds, { once: true });
  } else {
    initQuickAdds();
  }
  document.addEventListener('shopify:section:load', (event) => placeQuickAdds(event.target));

  const closeDialog = (dialog) => {
    if (!dialog || !dialog.open) return;
    dialog.classList.remove('is-opening');
    dialog.close();
    document.documentElement.classList.remove('ba-qa-open');
  };

  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-ba-quick-add-open]');
    if (open) {
      event.preventDefault();
      event.stopPropagation();
      const dialog = document.getElementById(open.dataset.baQuickAddOpen);
      if (dialog) {
        dialog.showModal();
        dialog.classList.add('is-opening');
        document.documentElement.classList.add('ba-qa-open');
      }
      return;
    }

    const close = event.target.closest('[data-ba-quick-add-close]');
    if (close) {
      event.preventDefault();
      closeDialog(close.closest('[data-ba-quick-add-dialog]'));
      return;
    }

    const variant = event.target.closest('[data-ba-variant]');
    if (variant && !variant.disabled) {
      event.preventDefault();
      const dialog = variant.closest('[data-ba-quick-add-dialog]');
      dialog.querySelectorAll('[data-ba-variant]').forEach((el) => {
        const selected = el === variant;
        el.classList.toggle('is-selected', selected);
        el.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      const input = dialog.querySelector('[data-ba-variant-input]');
      const price = dialog.querySelector('[data-ba-quick-add-price]');
      const image = dialog.querySelector('[data-ba-quick-add-image]');
      const net = dialog.querySelector('[data-ba-qa-net]');
      const unit = dialog.querySelector('[data-ba-qa-unit]');
      const mrp = dialog.querySelector('[data-ba-qa-mrp]');
      const setCompliance = (el, value, prefix = '') => {
        if (!el) return;
        const clean = (value || '').trim();
        el.hidden = !clean;
        el.textContent = clean ? `${prefix}${clean}` : '';
      };
      if (input) input.value = variant.dataset.variantId;
      if (price) price.innerHTML = variant.dataset.variantPrice;
      setCompliance(net, variant.dataset.variantNet);
      setCompliance(unit, variant.dataset.variantUnitPrice);
      setCompliance(mrp, variant.dataset.variantMrp, 'MRP ');
      if (image && variant.dataset.variantImage) {
        image.src = variant.dataset.variantImage;
        image.srcset = '';
        image.alt = variant.dataset.variantImageAlt || '';
      }
      return;
    }
  });

  document.addEventListener('click', (event) => {
    const dialog = event.target.closest('[data-ba-quick-add-dialog]');
    if (dialog && event.target === dialog) closeDialog(dialog);
  });

  document.addEventListener('cancel', (event) => {
    if (event.target.matches('[data-ba-quick-add-dialog]')) {
      document.documentElement.classList.remove('ba-qa-open');
    }
  }, true);

  document.addEventListener('cart:change', () => {
    document.querySelectorAll('[data-ba-quick-add-dialog][open]').forEach(closeDialog);
    const active = document.activeElement?.closest?.('[data-ba-quick-add]');
    if (!active) return;
    const trigger = active.querySelector('[data-ba-quick-add-trigger]');
    if (!trigger) return;
    const original = trigger.innerHTML;
    trigger.classList.add('is-added');
    trigger.innerHTML = '<span aria-hidden="true">✓</span><span>Added</span>';
    window.setTimeout(() => {
      trigger.classList.remove('is-added');
      trigger.innerHTML = original;
    }, 1400);
  });
})();
